import FilterJsonMiddleware from '../helpers/filterJsonMiddleware';

export const menuItems = new FilterJsonMiddleware([

    //#region Standard Dashboard Routes.
    {
        id: 1,
        isLayout: true
    },
    {
        id: 2,
        label: "menuitems.statistics.text",
        icon: "bx bx-stats",
        link: "/statistics"
    },
    //#region Custom Dashboard Routes.

    //write your menue items hear.
    {
        id: 111,
        label: "menuitems.form.artist.text",
        icon: "bx-file",
        link: "/form/artist",
        permission:{
            filter: 'any',
            values: ['show_artist', 'show_details_artist']

        },
    },
    {
        id: 100,
        label: "menuitems.exportData.text",
        icon: " bx-download",
        link: "/exportData",
        permission:{
            filter: 'any',
            values: ['export_to_excel_artist']
        },
    },
    {
        id: 3,
        label: "menuitems.posts.text",
        icon: "bx-news",
        link: "/posts",
        permission:{
            filter: 'any',
            values: ['show_post', 'add_post', 'edit_post', 'delete_post']
        },
    },

    {
        id: 4,
        label: "menuitems.offer.text",
        icon: "bx-news",
        link: "/offer",
        permission:{
            filter: 'any',
            values: ['show_blog', 'add_blog', 'edit_blog', 'delete_blog']
        },
    },
    
    {
        id: 5,
        label: "menuitems.links.text",
        icon: "bx-shape-circle",
        link: "/links",
        permission:{
            filter: 'any',
            values: ['show_link', 'add_link', 'edit_link', 'delete_link']
        }
    },

    {
        id: 6,
        label: "menuitems.images.text",
        icon: "bx-images",
        link: "/images",
        permission:{
            filter: 'any',
            values: ['show_image', 'add_image', 'edit_image', 'delete_image']
        }
    },

    {
        id: 7,
        label: "menuitems.videos.text",
        icon: "bxs-videos",
        link: "/videos",
        permission:{
            filter: 'any',
            values: ['show_video', 'add_video', 'edit_video', 'delete_video']
        }
    },

    {
        id: 8,
        label: "menuitems.quotation.text",
        icon: "bxs-quote-right",
        link: "/quotation",
        permission:{
            filter: 'any',
            values: ['edit_quotation']
        }
    },
    
    {
        id: 9,
        label: "menuitems.social-media.text",
        icon: "bxl-facebook-square",
        link: "/social-media",
        permission:{
            filter: 'any',
            values: ['edit_social_media']
        },
    },

    {
        id: 10,
        label: "menuitems.attachments.text",
        icon: "bxs-file-doc",
        link: "/attachments",
        permission:{
            filter: 'any',
            values: ['show_attachment', 'add_attachment', 'edit_attachment', 'delete_attachment']
        },
    },

    {
        id: 11,
        label: "menuitems.about.text",
        icon: "bxs-help-circle",
        link: "/about",
        permission:{
            filter: 'any',
            values: ['edit_about']
        },
    },

    //#endregion
    {
        id: 12,
        label: "menuitems.admins.text",
        icon: "bxs-user-detail",
        link: "/admins",
        permission:{
            filter: 'any',
            values: ['show_user', 'add_user', 'edit_user', 'delete_user']
        },
    },
    {
        id: 13,
        label: "menuitems.account.text",
        icon: "bxs-lock",
        link: "/account"
    },
    {
        id: 14,
        label: "menuitems.log.text",
        icon: "bx-group",
        link: "/admins/log_activity",
        permission:{
            filter: 'any',
            values: ['show_logs']
        },
    },
    //#endregion
]).data

